import { useUrlCustomField } from '@atlassian/jira-issue-field-url';
import { URL_CF_TYPE } from '@atlassian/jira-platform-field-config';
import {
	assertClipboardHasPlainTextFormat,
	useGenericClipboardHandler,
} from '../../../clipboard-handler/utils';
import type { ClipboardItem, ListIssueFieldTransformed, PasteHandler } from '../../../types';
import { createClipboardHelperComponent } from '../../utils';

const getPastedValue = (clipboardItem: ClipboardItem): string | null => {
	if (!assertClipboardHasPlainTextFormat(clipboardItem)) {
		return null;
	}

	return clipboardItem.plainText;
};

const useUrlClipboardHandler: PasteHandler = (
	issue: { key: string },
	field: ListIssueFieldTransformed,
) => {
	const [, { saveValue }] = useUrlCustomField({
		issueKey: issue.key,
		fieldKey: field?.fieldId,
	});

	return useGenericClipboardHandler(field, getPastedValue, saveValue);
};

const UrlClipboardHelper = createClipboardHelperComponent(useUrlClipboardHandler);

export const urlClipboardHandler = {
	[URL_CF_TYPE]: UrlClipboardHelper,
};
